module.exports = __webpack_public_path__ + "static/homepage-image1-1d2fb9ead9d93d92b3126d7e7160cd3b.jpg";